import Sdata from '@/database/sdata'

let g_entity = 'studio'
let g_url    = 'studio'
let g_pkey   = ['uid']
Sdata.addConfig( g_entity, g_pkey, g_url )

export default class Studio extends Sdata
{
  static entity = g_entity
  static url    = g_url
}